import React from "react";
import { Modal, Button } from "react-bootstrap";

const AddProfilePhotoModal = ({ show, onHide, onPickPhoto }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold text-main f-20 w-100 text-center">
          Add Your Profile Photo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center p-4">
        <p className="text-muted f-16 mb-4">
          A profile photo makes it easier for our community to identify you and
          improves your event experience.
        </p>
        <div className="d-flex flex-column gap-3">
          <Button
            className="btn btn-orange-lg w-100 rounded-5 py-2"
            onClick={onPickPhoto}
          >
            Pick Photo
          </Button>
          {/* <Button
            variant="link"
            className="text-decoration-none text-muted fw-semibold"
            onClick={onHide}
          >
            Cancel
          </Button> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddProfilePhotoModal;
